import * as _ from 'lodash';

// eslint-disable-next-line import/no-cycle
import * as Filter from '../../util/filters';
import * as FilterTypes from '../../util/filterTypes';
import {type DataDogPanelType} from '../../util/panelTypes';
import * as QueryTS from '../../util/queryTypes';
import * as RunTypes from '../../util/runTypes';
import * as Types from './types';

export interface QueryToRunsDataQueryParams {
  selectionsAsFilters?: boolean;
  mergeFilters?: FilterTypes.Filter<RunTypes.Key>;
  disableGrouping?: boolean;
}

export function toRunsDataQuery(
  query: QueryTS.Query,
  params: QueryToRunsDataQueryParams | undefined,
  attrs: Partial<Types.Query> & {
    panelType: DataDogPanelType;
  }
): Types.Query {
  let queries: QueryTS.SingleQuery[] = [];
  const inParams = params || {};
  if (query.runSets == null || query.runSets.length === 0) {
    queries = [_.cloneDeep(query)];
    if (inParams.selectionsAsFilters && query.selections != null) {
      queries[0].filters = Filter.And([query.filters, query.selections]);
    }
  } else {
    queries = query.runSets
      .filter(rs => rs.enabled)
      .map(rs => {
        const entityName = rs.entityName || query.entityName;
        const projectName = rs.projectName || query.projectName;
        const filterClauses = [query.filters, rs.filters];
        if (inParams.mergeFilters) {
          filterClauses.push(inParams.mergeFilters);
        }
        const filters = Filter.And(filterClauses);

        const selectionClauses: Array<FilterTypes.Filter<RunTypes.Key>> = [];
        if (query.selections) {
          selectionClauses.push(query.selections);
        }
        if (rs.selections) {
          selectionClauses.push(rs.selections);
        }
        let selections: FilterTypes.Filter<RunTypes.Key> =
          Filter.MATCH_NONE_FILTER;
        if (selectionClauses.length > 0) {
          selections = Filter.And(selectionClauses);
        }

        return {
          entityName,
          filters: inParams.selectionsAsFilters
            ? Filter.And([filters, selections])
            : filters,
          grouping: inParams.disableGrouping ? [] : rs.grouping,
          id: rs.id,
          internalProjectId: rs.project?.id,
          name: rs.name,
          projectName,
          selections: inParams.selectionsAsFilters
            ? Filter.MATCH_NONE_FILTER
            : selections,
          sort: rs.sort,
          panelType: attrs?.panelType ?? 'unknown',
        };
      });
  }
  return {
    aggregationKeys: query.aggregationKeys,
    configKeys: query.configKeys,
    displayName: query.displayName,
    enableArtifactCounts: query.enableArtifactCounts,
    enableTags: query.enableTags,
    entityName: query.entityName,
    internalProjectId: query.internalProjectId,
    keysLoading: query.keysLoading || false,
    pollInterval: query.pollInterval,
    projectName: query.projectName,
    queries,
    runName: query.runName,
    summaryKeys: query.summaryKeys,
    wandbKeys: query.wandbKeys,
    ...attrs,
  };
}
